import React from 'react';

class CustomButton extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {

        const { disabled, onClick, title, icon, image} = this.props;

        return (
            <>
                <div className={'swift-button ' + (disabled ? 'disabled' : '')} onClick={onClick}>
                    {icon || <img src={image}
                    width={18} height={18} />}  <p>{title}</p>
                </div>
            </>
        )

    }

}

export default CustomButton;